import { ItemsPDFWrapper } from '../../../../../features/ui'
import { CodedDataType } from '../../../../../tables'
import { PurchaseOrder } from '../../../state/types'
import { PurchasePDFPage } from "./purchasePDFPage"
import { Item } from "../../../../operations"

type Props = {
    id: string
    purchase: PurchaseOrder
    previewMode?: boolean
}

export const PurchasePDF = (props: Props) => {
    const { id, purchase, previewMode } = props

    const renderPDFPage = (
        pageIndex: number,
        dataType: CodedDataType,
        items: Item[],
        pagesAmount: number
    ) => (
        <PurchasePDFPage
            pageIndex={pageIndex}
            purchase={dataType as PurchaseOrder}
            items={items}
            pagesAmount={pagesAmount}
        />
    )

    return (
        <ItemsPDFWrapper
            id={id}
            dataType={purchase}
            items={purchase.items}
            previewMode={previewMode}
            renderPDFPage={renderPDFPage}
        />
    )
}
